import Class from "../jquery_class";

export default Class.extend({
  init: function(id, firstName, lastName) {
    this.id = id;
    this.first_name = firstName || '';
    this.last_name = lastName || '';
  },

  logged_in: function() {
    return this.id;
  },

  initials: function() {
    return this.first_name.substr(0, 1) + this.last_name.substr(0, 1);
  }
});
